import { getDesktop } from '../../desktop/desktop';

const DEFERRED_PREFIXES = ['skjv-store/studies/', 'skjv-store/study-groups/'];

/**
 * Pull the deferred study-library snapshot (studies + study-groups) from the
 * desktop shell and reconcile the localStorage mirror with it. The sync boot
 * snapshot deliberately excludes these namespaces — hundreds of per-study
 * folders would hold first scripture paint hostage — so last session's
 * mirror paints instantly and this pass makes it truthful.
 *
 * Returns false in the browser (no shell — the sync mirror is already
 * authoritative) or when the bridge predates deferredSnapshot().
 */
export async function hydrateDeferredLibrary(): Promise<boolean> {
  const desktop = getDesktop();
  if (!desktop?.deferredSnapshot) return false;

  const entries = await desktop.deferredSnapshot();
  const seen = new Set<string>();
  for (const { namespace, key, json } of entries) {
    const storageKey = `skjv-store/${namespace}/${key}`;
    localStorage.setItem(storageKey, json);
    seen.add(storageKey);
  }
  // Drop mirror entries whose disk record vanished (external delete).
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i);
    if (!k || seen.has(k)) continue;
    if (DEFERRED_PREFIXES.some((prefix) => k.startsWith(prefix))) {
      localStorage.removeItem(k);
    }
  }
  return true;
}
